import React from 'react'
import img1 from '../../assets/coursecard/1.jpg'
import img2 from '../../assets/coursecard/2.jpg'
import img3 from '../../assets/coursecard/3.jpg'
import img4 from '../../assets/coursecard/4.jpg'
import img5 from '../../assets/coursecard/5.jpg'
import img6 from '../../assets/coursecard/6.jpg'
import img7 from '../../assets/coursecard/7.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
library.add(fas)

const Coursefresher = () => {
  return (
    <div className='course-sec'>
        <div class="row align-items-center">
                            <div class="col-lg-4 mb-5">
                                <a href='/product/physical-design'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img1} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                            <div class="card-box-rating">Discover, Learn, Grow</div>
                                            <div class="card-content-title mb-3">Physical Design</div>
                                            <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                            <div class="card-box-duration d-flex justify-content-between">
                                                <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </a> 
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/design-for-test/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img2} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Design For Test (DFT)</div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                          </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/asic-verification/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img3} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">ASIC Verification
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/analog-layout-design/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img4} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Analog Layout Design
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/rtl-coding-fpga-design/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img5} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">RTL Coding and FPGA Design
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/analog-circuit-design/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img6} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Analog Circuit Design
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>16 Weeks | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href='/product/embedded-systems-training/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img7} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                            <div class="card-box-rating">Discover, Learn, Grow</div>
                                            <div class="card-content-title mb-3">Embedded Systems Training</div>
                                            <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                            <div class="card-box-duration d-flex justify-content-between">
                                                <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            

         </div>
    </div>
  )
}

export default Coursefresher